module.exports = __webpack_public_path__ + "static/img/1_2_2.9c4c0e9e.jpg";